import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { getSubTags, hasTag } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { AirportService } from '../airport.service';
import { EditCampingComponent } from '../edit-camping/edit-camping.component';
var ServicesComponent = /** @class */ (function () {
    function ServicesComponent(_toggleService, _snackBar, _editTransportationDialog, _airportService, _editCampingDialog) {
        this._toggleService = _toggleService;
        this._snackBar = _snackBar;
        this._editTransportationDialog = _editTransportationDialog;
        this._airportService = _airportService;
        this._editCampingDialog = _editCampingDialog;
        this.getSubTags = getSubTags;
    }
    ServicesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    };
    Object.defineProperty(ServicesComponent.prototype, "hasServices", {
        get: function () {
            return getSubTags(this.airport.airportTags, 'Services::').length > 0
                || getSubTags(this.airport.airportTags, 'Transportation::').length > 0
                || getSubTags(this.airport.airportTags, 'Fuel::').length > 0
                || getSubTags(this.airport.airportTags, 'Customs::').length > 0
                || getSubTags(this.airport.airportTags, 'Activities::').length > 0
                || hasTag(this.airport.airportTags, 'Camping On Field');
        },
        enumerable: true,
        configurable: true
    });
    ServicesComponent.prototype.reloadAirport = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ServicesComponent.prototype.openEditTagsDialog = function (group, except, title) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.airport,
            tagsGroup: group,
            except: except,
            title: title
        };
        dialogConfig.width = '60%';
        var dialogRef = this._editTransportationDialog.open(EditTagsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            if (isSuccess) {
                // this.loadAllTags();
                _this.reloadAirport(_this.airport.identifier);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    ServicesComponent.prototype.getCampingOnFieldText = function () {
        var retString = 'None reported';
        if (hasTag(this.airport.airportTags, 'Camping On Field')) {
            retString = 'Available';
        }
        if (getSubTags(this.airport.airportTags, 'Camping On Field::Availability::').length > 0) {
            retString = '';
        }
        return retString;
    };
    ServicesComponent.prototype.getCampingAvailabilityText = function () {
        var retString = '';
        if (hasTag(this.airport.airportTags, 'Camping On Field::Availability::Year-Round')) {
            retString = 'Year-Round';
        }
        if (hasTag(this.airport.airportTags, 'Camping On Field::Availability::Seasonal')) {
            retString = 'Seasonal';
        }
        if (hasTag(this.airport.airportTags, 'Camping On Field::Availability::Special Events Only')) {
            retString = 'Special Events Only';
        }
        if (hasTag(this.airport.airportTags, 'Camping On Field::Availability::Reservation Required')) {
            retString += ', Reservation Required';
        }
        return retString;
    };
    ServicesComponent.prototype.openEditCampingDialog = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            airport: this.airport
        };
        dialogConfig.width = '400px';
        var dialogRef = this._editCampingDialog.open(EditCampingComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            if (isSuccess) {
                // this.loadAllTags();
                _this.reloadAirport(_this.airport.identifier);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return ServicesComponent;
}());
export { ServicesComponent };
